import React, { useContext, useEffect } from "react";
import "../Styles/dokmen-collection.css";
import { Link } from "react-router-dom";
import { CartState } from "../Context/Context";
import ProductItems from "./ProductItems";
import ProductContext from "../Context/productContext";

export default function Dokmencollection() {
  const {
    state: { products },
  } = CartState();
  const context = useContext(ProductContext);
  const { collectionProducts,fetchCollectionProduct } = context;

  useEffect(() => {
   fetchCollectionProduct()
  }, [])
  


  return (
    <div className="dokmen-collection">
      <h2 className="collection-txt">Dokmen Top selling</h2>

      <div className="product-container">
      
        {collectionProducts.map((item) => {
            return (
              <ProductItems
              item={item}
                key={item.id}
                // image={item.image}
                // title={item.title}
                // price={item.price}
                // specialprice={item.specialprice}
                // stock={item.stock}
              />
            );
          
          
          
        })}
      </div>

      <div className="product-btn">
        <Link to="/products">
          <button>view all products</button>
        </Link>
      </div>
    </div>
  );
}
